import type FormHandler from '../forms/FormHandler';
import IFormPostHandler, { FormPostResult } from '../forms/IFormPostHandler';
import LevelFirstFormService from './LevelFirstFormService';
import { ValidationResult } from '../forms/ValidationService';

class LevelFirstFormPostHandler implements IFormPostHandler {
  formHandler: FormHandler;

  constructor(formHandler: FormHandler) {
    this.formHandler = formHandler;
  }

  async post() {
    const data = this.formHandler.getFormData();

    const {
      DesignationId,
      FundId,
      MembershipLevelTitle,
      MembershipLevelId,
      __RequestVerificationToken,
      ...CustomForm
    } = data;

    const response = await LevelFirstFormService.add({
      DesignationId,
      FundId,
      MembershipLevelTitle,
      MembershipLevelId,
      __RequestVerificationToken,
      CustomForm,
    });

    const returnValue:FormPostResult = {
      data: response,
      validationResult: {
        validationResults: [],
        isValid: true,
      },
    };

    if (response.validationResults) {
      returnValue.validationResult.isValid = response.validationResults.every((el) => el.isValid);
      
      returnValue.validationResult.validationResults = response.validationResults as ValidationResult[];
    }

    return returnValue;
  }
}

export default LevelFirstFormPostHandler;
